"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var delete_1 = require("./delete");

var ui_1 = require("../ui");

var Footer = function Footer(props) {
  var link = props.link,
      promise = props.promise,
      id = props.id,
      onBack = props.onBack,
      onDelete = props.onDelete,
      _props$showDelete = props.showDelete,
      showDelete = _props$showDelete === void 0 ? true : _props$showDelete;
  return react_1.default.createElement(core_1.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center"
  }, react_1.default.createElement(ui_1.BackButton, {
    onClick: onBack || link
  }), showDelete && react_1.default.createElement(delete_1.DeleteWRedirect, {
    promise: promise,
    id: id,
    link: link,
    onDelete: onDelete
  }));
};

exports.default = Footer;